import Cookies from "js-cookie"

function user_info(){
  return Cookies.get("authUser") ?  JSON.parse(Cookies.get("authUser")) : null 
}

const isAdmin = user_info()?.user_group[0].title === 'admin' ? true : false

export {isAdmin}
export default user_info